import { render, staticRenderFns } from "./EditTaxCode.vue?vue&type=template&id=39bc1341&scoped=true&"
import script from "./EditTaxCode.vue?vue&type=script&lang=js&"
export * from "./EditTaxCode.vue?vue&type=script&lang=js&"
import style0 from "./EditTaxCode.vue?vue&type=style&index=0&id=39bc1341&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc1341",
  null
  
)

export default component.exports